// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file service_manager_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyRequestSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { ReorderRequestSchema } from "./reorder_pb";
import { file_reorder } from "./reorder_pb";
import type { ReservationService } from "./reservation_service_pb";
import { file_reservation_service } from "./reservation_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file service_manager_service.proto.
 */
export const file_service_manager_service: GenFile = /*@__PURE__*/
  fileDesc("Ch1zZXJ2aWNlX21hbmFnZXJfc2VydmljZS5wcm90bxILZ3JwYy5hcGkudjEiTQoZUmVzZXJ2YXRpb25TZXJ2aWNlUmVxdWVzdBIwCgdzZXJ2aWNlGAEgASgLMh8uZ3JwYy5hcGkudjEuUmVzZXJ2YXRpb25TZXJ2aWNlIk4KGlJlc2VydmF0aW9uU2VydmljZVJlc3BvbnNlEjAKB3NlcnZpY2UYASABKAsyHy5ncnBjLmFwaS52MS5SZXNlcnZhdGlvblNlcnZpY2UiUwofTWVyZ2VSZXNlcnZhdGlvblNlcnZpY2VzUmVxdWVzdBISCgpzZXJ2aWNlX2lkGAEgASgDEhwKFHRvX21lcmdlX3NlcnZpY2VfaWRzGAIgAygDImwKJUNoZWNrTWVyZ2VSZXNlcnZhdGlvblNlcnZpY2VzUmVzcG9uc2USMAoHc2VydmljZRgBIAEoCzIfLmdycGMuYXBpLnYxLlJlc2VydmF0aW9uU2VydmljZRIRCgljb25mbGljdHMYAiADKAkyjgQKFVNlcnZpY2VNYW5hZ2VyU2VydmljZRJiCg11cGRhdGVTZXJ2aWNlEiYuZ3JwYy5hcGkudjEuUmVzZXJ2YXRpb25TZXJ2aWNlUmVxdWVzdBonLmdycGMuYXBpLnYxLlJlc2VydmF0aW9uU2VydmljZVJlc3BvbnNlMAESVAoMbGlzdFNlcnZpY2VzEhkuZ3JwYy5hcGkudjEuRW1wdHlSZXF1ZXN0GicuZ3JwYy5hcGkudjEuUmVzZXJ2YXRpb25TZXJ2aWNlUmVzcG9uc2UwARJZCg9yZW9yZGVyU2VydmljZXMSGy5ncnBjLmFwaS52MS5SZW9yZGVyUmVxdWVzdBonLmdycGMuYXBpLnYxLlJlc2VydmF0aW9uU2VydmljZVJlc3BvbnNlMAESdgoSY2hlY2tNZXJnZVNlcnZpY2VzEiwuZ3JwYy5hcGkudjEuTWVyZ2VSZXNlcnZhdGlvblNlcnZpY2VzUmVxdWVzdBoyLmdycGMuYXBpLnYxLkNoZWNrTWVyZ2VSZXNlcnZhdGlvblNlcnZpY2VzUmVzcG9uc2USaAoNbWVyZ2VTZXJ2aWNlcxIsLmdycGMuYXBpLnYxLk1lcmdlUmVzZXJ2YXRpb25TZXJ2aWNlc1JlcXVlc3QaJy5ncnBjLmFwaS52MS5SZXNlcnZhdGlvblNlcnZpY2VSZXNwb25zZTABQgZaBC47cGJiBnByb3RvMw", [file_empty, file_reorder, file_reservation_service]);

/**
 * @generated from message grpc.api.v1.ReservationServiceRequest
 */
export type ReservationServiceRequest = Message<"grpc.api.v1.ReservationServiceRequest"> & {
  /**
   * @generated from field: grpc.api.v1.ReservationService service = 1;
   */
  service?: ReservationService | undefined;
};

/**
 * Describes the message grpc.api.v1.ReservationServiceRequest.
 * Use `create(ReservationServiceRequestSchema)` to create a new message.
 */
export const ReservationServiceRequestSchema: GenMessage<ReservationServiceRequest> = /*@__PURE__*/
  messageDesc(file_service_manager_service, 0);

/**
 * @generated from message grpc.api.v1.ReservationServiceResponse
 */
export type ReservationServiceResponse = Message<"grpc.api.v1.ReservationServiceResponse"> & {
  /**
   * @generated from field: grpc.api.v1.ReservationService service = 1;
   */
  service?: ReservationService | undefined;
};

/**
 * Describes the message grpc.api.v1.ReservationServiceResponse.
 * Use `create(ReservationServiceResponseSchema)` to create a new message.
 */
export const ReservationServiceResponseSchema: GenMessage<ReservationServiceResponse> = /*@__PURE__*/
  messageDesc(file_service_manager_service, 1);

/**
 * @generated from message grpc.api.v1.MergeReservationServicesRequest
 */
export type MergeReservationServicesRequest = Message<"grpc.api.v1.MergeReservationServicesRequest"> & {
  /**
   * @generated from field: int64 service_id = 1;
   */
  serviceId: bigint;

  /**
   * @generated from field: repeated int64 to_merge_service_ids = 2;
   */
  toMergeServiceIds: bigint[];
};

/**
 * Describes the message grpc.api.v1.MergeReservationServicesRequest.
 * Use `create(MergeReservationServicesRequestSchema)` to create a new message.
 */
export const MergeReservationServicesRequestSchema: GenMessage<MergeReservationServicesRequest> = /*@__PURE__*/
  messageDesc(file_service_manager_service, 2);

/**
 * @generated from message grpc.api.v1.CheckMergeReservationServicesResponse
 */
export type CheckMergeReservationServicesResponse = Message<"grpc.api.v1.CheckMergeReservationServicesResponse"> & {
  /**
   * @generated from field: grpc.api.v1.ReservationService service = 1;
   */
  service?: ReservationService | undefined;

  /**
   * @generated from field: repeated string conflicts = 2;
   */
  conflicts: string[];
};

/**
 * Describes the message grpc.api.v1.CheckMergeReservationServicesResponse.
 * Use `create(CheckMergeReservationServicesResponseSchema)` to create a new message.
 */
export const CheckMergeReservationServicesResponseSchema: GenMessage<CheckMergeReservationServicesResponse> = /*@__PURE__*/
  messageDesc(file_service_manager_service, 3);

/**
 * @generated from service grpc.api.v1.ServiceManagerService
 */
export const ServiceManagerService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.ServiceManagerService.updateService
   */
  updateService: {
    methodKind: "server_streaming";
    input: typeof ReservationServiceRequestSchema;
    output: typeof ReservationServiceResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ServiceManagerService.listServices
   */
  listServices: {
    methodKind: "server_streaming";
    input: typeof EmptyRequestSchema;
    output: typeof ReservationServiceResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ServiceManagerService.reorderServices
   */
  reorderServices: {
    methodKind: "server_streaming";
    input: typeof ReorderRequestSchema;
    output: typeof ReservationServiceResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ServiceManagerService.checkMergeServices
   */
  checkMergeServices: {
    methodKind: "unary";
    input: typeof MergeReservationServicesRequestSchema;
    output: typeof CheckMergeReservationServicesResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ServiceManagerService.mergeServices
   */
  mergeServices: {
    methodKind: "server_streaming";
    input: typeof MergeReservationServicesRequestSchema;
    output: typeof ReservationServiceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_service_manager_service, 0);

